import { render, staticRenderFns } from "./ThePrivacy.vue?vue&type=template&id=1685b7d8&scoped=true&"
import script from "./ThePrivacy.vue?vue&type=script&lang=js&"
export * from "./ThePrivacy.vue?vue&type=script&lang=js&"
import style0 from "./ThePrivacy.vue?vue&type=style&index=0&id=1685b7d8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1685b7d8",
  null
  
)

export default component.exports